import { useContext, createContext, useState, useEffect } from "react";
import axios from 'axios';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const [sesiune, setSesiune] = useState(null);
    const [token, setToken] = useState(localStorage.getItem("4sChatInfo") || "");
    const backend = window.BACKEND + "/chat";

    useEffect(() => {
        if (token && token != "") {
            axios.post(backend + "/getTokenInfo", { token: token })
                .then(function (res) {

                    if (res.data) {
                        setSesiune(res.data);
                    }

                }).catch(function (r) {
                    setToken("");
                    localStorage.clear();
                });
        }
    }, [token])

    const openSession = (info) => {
        axios.post(backend + "/openSession", info)
            .then(function (res) {
                var r = res.data;

                if (r && r.token) {
                    setToken(r.token);
                    localStorage.setItem("4sChatInfo", r.token);

                }

            })
            .catch(function (r) {

                console.log("login_err");
            });
    }

    const clear = () => {
        localStorage.clear();
        setToken("");
        setSesiune("");
    }

    return <AuthContext.Provider value={{ backend, token, sesiune, setSesiune, openSession, clear }}>
        {children}
    </AuthContext.Provider>;
};

export default AuthProvider;

export const useAuth = () => {
    return useContext(AuthContext);
};
